import React, { useContext, useEffect, useState} from 'react';

import Modal from 'react-modal';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';


import '../../styles/profile.css'

import {
    getConfig,
    buildSearchesOptionsConfig
  } from "../../config/config-centros-helper";

import constructName from '../../utils/constructName';
import centros_pdf from '../../data/centros_pdf';
import { UniversityContext } from '../../routes/AppRouter';
import { centros_corfo } from '../../data';

const { searchKey, endpointBase } = getConfig();
const config = {
/*   searchQuery: {
    facets: buildFacetConfigFromConfig(),
    ...buildSearchOptionsFromConfig()
  },
  autocompleteQuery: buildAutocompleteQueryConfig(),
  alwaysSearchOnInitialLoad: true, */
  searchesOption: buildSearchesOptionsConfig()
};


const AppSearchClient = require('@elastic/app-search-node')
  
const baseUrlFn = () => endpointBase + '/api/as/v1/';
const clientDirect = new AppSearchClient(undefined, searchKey, baseUrlFn);

Modal.setAppElement('#root');
//* Este es el modal del perfil de centros abierto desde investigador (es una copia del componente centrosProfile.js)

export default (props) =>{

    const [ universidad ] = useContext(UniversityContext)
    console.log(universidad.id+ ' EN modal de centros')

    const [data, setData] = useState(null)
    const [dataLabel, setDataLabel] = useState('Cargando informacion...')

    useEffect(() => {
        getCentro(props.id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getCentro = (id) =>{
            const tmpId = ('"').concat(id).concat('"').replaceAll("<em>","").replaceAll("</em>","");
            console.log("rut recibido : ", id)
            const searches = [
            { query: tmpId, options:config.searchesOption }
            ];
            clientDirect
            .multiSearch(universidad.centros.engineName, searches)
            .then(response => {
                setData(response[0].results[0]); 
                if(response[0].results[0]!==0)
                { 
                    setDataLabel('')
                }
            })
            .catch(error => { console.log('Error en el cargado de la data '+error.errorMessages); setData(null); setDataLabel('No se pudo consultar registros') });
    }

    const printFicha = ( actualCentroName ) => {
        for (let indice = 0; indice < centros_pdf.length; indice++) {
            const centroPDF= centros_pdf[indice];
            if( actualCentroName.toLowerCase() === centroPDF.name ){
                return ( <a className="link" target="_blank"  rel="noopener noreferrer" href={centroPDF.url}> ver ficha </a>  )
            }
            
        }
    }

    return (
        data ? (
            <>
                <div className="modal-title">
                    <h2 className="modal-title__name ">{ data.nombre_centro?.raw }</h2>
                </div>
                                    
                <div className="modal-body">
                    <div className="modal-profile">
                        <ul className="list-profile">
                            <li>
                                <span>
                                    <b style={{textTransform: 'capitalize'}} dangerouslySetInnerHTML={{__html: constructName(data)}}></b>
                                </span>
                            </li>
                            <li>
                                <span dangerouslySetInnerHTML={{__html: data.centro?.snippet}}></span>
                            </li>
                        </ul>
                    </div>
                    <div className="modal-tabs">
                        <Tabs >
                            <TabList>
                                <Tab>
                                    <b className="tab-title">Overview</b>
                                </Tab>

                                <Tab>
                                    <b className="tab-title">Equipo</b>
                                </Tab>

                                {
                                    //data.lineainvestigacion.raw.length > 0 &&
                                    (
                                        <Tab>
                                            <b className="tab-title">Investigación</b>
                                        </Tab>
                                    )
                                }
                                
                                { 
                                    //data.publicaciones.raw.length > 0 && 
                                    (
                                        <Tab>
                                            <b className="tab-title">Publicaciones</b>
                                        </Tab>
                                    )
                                }
                                
                                {
                                    
                                    //data.proyectos?.raw.length > 0 && 
                                    (
                                        <Tab>
                                            <b className="tab-title">Proyectos</b>
                                        </Tab>
                                    )
                                }

                                <Tab>
                                    <b className="tab-title">Partners</b>
                                </Tab>

                                {
                                    //data.equipamiento?.raw.length > 0 && 
                                    (
                                        <Tab>
                                            <b className="tab-title">Equipamiento</b>
                                        </Tab>
                                    )
                                }

                                <Tab>
                                    <b className="tab-title"> Servicios </b>
                                </Tab>
                            </TabList>

                            {/* Overview */}
                            <TabPanel> 
                                {/*}
                                <div>
                                    <h4>Nombre</h4>
                                    <span dangerouslySetInnerHTML={{__html: data.nombre_centro?.snippet}}></span>
            </div>  */  }
                                <div>
                                    <h4>Descripción</h4>
                                    {
                                        data.descripcion.snippet === null || data.descripcion.snippet === ""
                                        ? ""
                                        : <span dangerouslySetInnerHTML={{__html: ` ${data.descripcion?.raw}`}}></span>
                                    }
                                    <br/>
                                </div>
                                <div>
                                    <h4>Propuesta de Valor</h4>
                                    {
                                        data.propuesta_valor.snippet === null || data.propuesta_valor.snippet === ""
                                        ? ""
                                        : <span dangerouslySetInnerHTML={{__html: ` ${data.propuesta_valor?.raw}`}}></span>
                                    }
                                </div>
                                <div>
                                    <h4>Ventajas Competitivas</h4>
                                    {
                                        data.ventajas_competitivas.snippet === null || data.ventajas_competitivas.snippet === ""
                                        ? ""
                                        : <span dangerouslySetInnerHTML={{__html: ` ${data.ventajas_competitivas?.raw}`}}></span>
                                    }
                                </div>
                                <div>
                                    {
                                        universidad.id !== "unab" && (
                                            <>
                                                <h4>Ficha del Centro </h4>
                                                    { 
                                                        printFicha(data.nombre_centro.snippet.replaceAll("<em>","").replaceAll("</em>",""))
                                                    }
                                            </>
                                        )
                                    }
                                </div>

                                {
                                    centros_corfo.map( centro =>{
                                        if( ( centro.nombre.toLowerCase() === data.nombre_centro?.raw.toLowerCase() ) && centro.universidad === data.universidad?.raw ){
                                            return (
                                                <div key={ centro.nombre }>
                                                    <a className='link link--corfo' href={centro.url} rel="noopener noreferrer" target="_blank">Este Centro pertenece a I+D inscrito en registro CORFO</a>
                                                </div>
                                            )
                                        } else {
                                            return <></>
                                        }
                                        
                                    })
                                }
                            </TabPanel>
                            
                            {/* Equipo */}
                            <TabPanel>
                                <div className="tabs-team">
                                    {
                                        data.investigadores.raw.map( (element, index) => {
                                            let elementJSON = JSON.parse(element, (key, value) => {
                                                if (key === 'tipo_investigador' || key === 'investigador') {
                                                    return value?.toLowerCase();
                                                }
                                                return value;
                                                })
                                            let tipo = elementJSON['tipo_investigador']
                                            if(tipo==='director'){
                                                return (
                                                    <button 
                                                        type="button" 
                                                        key={index}
                                                        className="teamButton"
                                                    >
                                                        <span className="modal-body-a teamButton__title">
                                                            {elementJSON['investigador']}
                                                        </span>
                                                        <span className="teamButton__position">
                                                            {elementJSON['tipo_investigador']}
                                                        </span>
                                                    </button>
                                                )
                                            }
                                            return <></> // linter
                                        })
                                    }  
                                    {
                                        data.investigadores.raw.map( (element, index) => {
                                            let elementJSON = JSON.parse(element, (key, value) => {
                                                if (key === 'tipo_investigador' || key === 'investigador') {
                                                    return value?.toLowerCase();
                                                }
                                                return value;
                                                })
                                            let tipo = elementJSON['tipo_investigador']
                                            if(tipo!=='director'){
                                                return (
                                                        <button 
                                                            key={index}
                                                            type="button" 
                                                            className="teamButton"
                                                        >
                                                            <span className="modal-body-a teamButton__title">
                                                                {elementJSON['investigador']}
                                                            </span>
                                                            <span className="teamButton__position">
                                                                {elementJSON['tipo_investigador']}
                                                            </span>
                                                        </button>//: {undefined}
                                                )
                                            }
                                            return <></> //linter
                                        })
                                    }   
                                </div>
                            </TabPanel>
                            {/* Investigación */}
                                {
                                    //data.lineainvestigacion.raw.length > 0 &&
                                    (
                                    <TabPanel>
                                        <div>

                                            {
                                                data.lineainvestigacion.raw.map( (element, index) => {
                                                    const investigacionWithoutRNJSON = element
                                                    let investigacion = JSON.parse(investigacionWithoutRNJSON)
                                                    return (
                                                        <div className="paddingLeft-20" key={index}>
                                                            <div className="modal-body-a">
                                                                {
                                                                investigacion['nombre_linea']?.split("\n").map(function(item, idx) {
                                                                    return (
                                                                        <>
                                                                            {item}
                                                                            <br />
                                                                        </>
                                                                    )
                                                                })
                                                                }

                                                            </div>
                                                            <div>
                                                                <span>
                                                                    {
                                                                        investigacion['desarrollo_tecnico']?.split("\n").map(function(item, idx) {
                                                                            return (
                                                                                <>
                                                                                    {item}
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <span>
                                                                    {
                                                                        investigacion['aplicaciones']?.split("\n").map(function(item, idx) {
                                                                            return (
                                                                                <>
                                                                                    {item}
                                                                                    <br />
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                </span>
                                                            </div>
                                                            <br></br>
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                    </TabPanel>

                                    )
                                }                                                                    

                            {/* Publicaciones */}
                                { 
                                //data.publicaciones.raw.length > 0 && 
                                    (
                                        <TabPanel>
                                            <div>

                                            {
                                                data.publicaciones.raw.map( (element, index) => {
                                                    let elementJSON = JSON.parse(element)
                                                    return (
                                                        <div className="paddingLeft-20" key={index}>
                                                            <div className="uppercase modal-body-a">{elementJSON['nombre']}</div>
                                                            <div>
                                                                <span>{elementJSON['autor']}</span>
                                                            </div>
                                                            <div>
                                                                <span>{elementJSON['anio']}</span>
                                                            </div>
                                                            <br></br>
                                                        </div>
                                                    )
                                                })
                                            }

                                            </div>
                                        </TabPanel>
                                    )
                                }                                                                    

                            {/* Proyectos */}
                                {
                                    //data.proyectos?.raw.length > 0 && 
                                    (
                                        <TabPanel>
                                            <div>

                                                {
                                                    data.proyectos.raw.map( (element, index) => {
                                                        let elementJSON = JSON.parse(element)
                                                        return (
                                                            <div className="paddingLeft-20" key={index}>
                                                                <div className="uppercase modal-body-a">{elementJSON['nombre']}</div>
                                                                <div>
                                                                    <span>Tipo de financiamiento: {elementJSON['institucion_financia']}</span>
                                                                </div>
                                                                <div>
                                                                    <span>Investigador Principal: {elementJSON['investigador_principal']}</span>
                                                                </div>
                                                                <br></br>
                                                            </div>
                                                        )
                                                    })
                                                }

                                            </div>
                                        </TabPanel>
                                    )
                                }                                                                    

                            {/* Partners */}
                            <TabPanel>
                                <ul>
                                    {
                                        data.partners?.raw.map( ( partnerJSON ) =>{
                                            const { partner } = JSON.parse( partnerJSON );
                                            return (
                                                <li key={ partner }> { partner } </li>
                                            )
                                        })
                                    }
                                </ul>
                                
                            </TabPanel>

                            {/* Equipamiento */}
                            <TabPanel>
                            { 
                                data.equipamiento===null || data.equipamiento.snippet===null?
                                <div></div>:
                                data.equipamiento.raw.map( (element, index) => {
                                    let elementJSON = JSON.parse(element)
                                    return (
                                            <div key={index}>
                                                <div className="paddingLeft-20" key={index}>
                                                    <div className="uppercase modal-body-a">{elementJSON['equipo']}</div>
                                                    <div>
                                                        <span>Descripci&oacute;n: {elementJSON['descripcion']}</span>
                                                    </div>
                                                    <div>
                                                        <span>Marca: {elementJSON['marca']}</span>
                                                    </div>
                                                    <br></br>
                                                </div>
                                                <br></br>
                                            </div>
                                        
                                    )
                                })
                            }
                                
                            </TabPanel>

                            {/* Servicios */}        
                            <TabPanel>
                                    {
                                        data.servicios?.raw && JSON.parse( data.servicios.raw).map( ( { servicio,descripcion,laboratorio }, index ) => {
                                            return (
                                                <div key={ index }>
                                                    {
                                                        descripcion && (
                                                            <>
                                                                <h4>
                                                                    Descripción
                                                                </h4>
                                                                <span>
                                                                    { descripcion }
                                                                </span>
                                                                <br />
                                                            </>
                                                        )
                                                    }

                                                    {
                                                        servicio && (
                                                            <>
                                                                <h4>
                                                                { servicio }
                                                                </h4>
                                                            </>
                                                        )
                                                    }                      
                                                    {
                                                        descripcion && (
                                                            <>
                                                                <p><b>{ descripcion }</b></p>
                                                                <br />
                                                            </>
                                                        )
                                                    }
                                                    
                                                    {
                                                        laboratorio && ( <span> { laboratorio } </span> )
                                                    }
                                                </div>
                                            )
                                        } )
                                    }
                            </TabPanel>
                        {/* !Fixme:  Revisar porque trae un arreglo como string en este punto, esta parte esta aislada del componente copia porque no funcionaba*/}     
                        </Tabs>
                    </div>
                </div>

            </>

        ) : <p>{ dataLabel }</p>
    )
}